import React, { useEffect } from 'react';
import { Button, Link } from '@material-ui/core';
import { Link as RouterLink } from "react-router-dom";
import { dateStringTicker } from '../common/helpers/DateHelpers';
import { formatToCurrency } from '../common/helpers/CurrencyHelpers';
import DataTable, { DataTableColumn } from '../Components/DataTable';
import { TickerItem } from '../RoundOverview/RoundOverviewModels';
import { friendlyName } from '../common/helpers/RoundHelper';
import { Freebet } from '../Freebets/FreebetModels';
import EditFreebetDialog from '../Freebets/EditFreebetDialog';


interface TickerTableProps {
  items: TickerItem[];
  roundColumnsVisible?: boolean;
  onSelect? : (item : TickerItem) => void;
}

const TickerTable: React.FC<TickerTableProps> = (props) => {
  const [selectedItemId, setSelectedItemId] = React.useState<number>(0);
  const [columns, setColumns] = React.useState<DataTableColumn<TickerItem>[]>([]);
  const [showFreebet, setShowFreebet] = React.useState<number>(0);

  useEffect(() => {
    refreshColumns();
  }, []);
  
  const refreshColumns = () => {
    var roundColsVisible : boolean = (props.roundColumnsVisible === undefined || props.roundColumnsVisible);
    var cols: DataTableColumn<TickerItem>[] = [
        { id: 'couponShareId', numeric: false, disablePadding: true, label: "Id", filterEnabled: true, renderValue: (row: TickerItem) => { return (<Link component={RouterLink} to={`couponView/${row.roundId}/${row.couponId}/${row.couponShareId}`}>{row.couponShareId}</Link>); } },
        { id: 'roundId', numeric: true, disablePadding: false, label: 'Round', filterEnabled: true, renderValue: (row: TickerItem) => { return (<Link component={RouterLink} to={`rounds/${row.roundId}`}>{row.roundId}</Link>); } },
        { id: 'roundTypeName', numeric: false, disablePadding: false, label: 'Type', filterEnabled: true, renderValue: (row: TickerItem) => { return friendlyName(row.roundTypeName); } },
        { id: 'deadline', numeric: false, disablePadding: false, label: 'Deadline', renderValue: (item: TickerItem) => { return dateStringTicker(item.deadline); }},
        { id: 'operatorId', numeric: false, disablePadding: false, label: 'Operator', filterEnabled: true },
        { id: 'agentName', numeric: false, disablePadding: false, label: 'Agent', filterEnabled: true, renderValue: (item: TickerItem) => { return item.agentName; } },
        { id: 'playerId', numeric: false, disablePadding: false, label: 'Player', filterEnabled: true },
        { id: 'couponId', numeric: false, disablePadding: false, label: 'Coupon', filterEnabled: true, renderValue: (row: TickerItem) => { return (<Link component={RouterLink} to={`coupons/${row.couponId}`}>{row.couponId}</Link>); } },
        { id: 'freebetId', numeric: false, disablePadding: false, label: 'Freebet', filterEnabled: true, renderValue: renderFreebet },
        { id: 'placedAt', numeric: false, disablePadding: false, label: 'Placed', renderValue: (item: TickerItem) => { return dateStringTicker(item.placedAt); }},
        { id: 'couponShareStatus', numeric: false, disablePadding: false, label: 'Status', filterEnabled: true, visible: true },
        { id: 'currency', numeric: false, disablePadding: false, label: 'Currency', filterEnabled: true, visible: true },
        { id: 'stake', numeric: true, disablePadding: false, label: 'Stake', renderValue: (item: TickerItem) => { return formatToCurrency(item.stake, undefined); } },
        { id: 'result', numeric: true, disablePadding: false, label: 'Result', renderValue: (item: TickerItem) => { return formatToCurrency(item.result, undefined); } },
        { id: 'fee', numeric: true, disablePadding: false, label: 'Fee', renderValue: (item: TickerItem) => { return formatToCurrency(item.fee, undefined); } },
        { id: 'agentFee', numeric: true, disablePadding: false, label: 'Agent Fee', renderValue: (item: TickerItem) => { return formatToCurrency(item.agentFee, undefined); } },
        { id: 'unitCurrency', numeric: false, disablePadding: false, label: 'Unit Currency', filterEnabled: true, visible: false },
        { id: 'unitStake', numeric: true, disablePadding: false, label: 'Unit Stake', renderValue: (item: TickerItem) => { return formatToCurrency(item.unitStake, item.unitCurrency); } },
        { id: 'unitResult', numeric: true, disablePadding: false, label: 'Unit Result', renderValue: (item: TickerItem) => { return formatToCurrency(item.unitResult, item.unitCurrency); }},
        { id: 'unitFee', numeric: true, disablePadding: false, label: 'Unit Fee', renderValue: (item: TickerItem) => { return formatToCurrency(item.unitFee, item.unitCurrency); } },
        { id: 'unitAgentFee', numeric: true, disablePadding: false, label: 'Unit Agent Fee', renderValue: (item: TickerItem) => { return formatToCurrency(item.unitAgentFee, item.unitCurrency); } },
    ];
    setColumns(cols);
  }
    
    const renderFreebet = (item : TickerItem) : any => {
      var freebetId : number = item.freebetId && item.freebetId > 0 ? item.freebetId : 0;
      if (freebetId > 0) {
        //return (<Link component={RouterLink} to={`editFreebet/${item.freebetId}`}>{item.freebetId}</Link>);
        return (<Button onClick={() => setShowFreebet(freebetId)}>{freebetId}</Button>);
      }
      return "";
    };
    const onSelect = (item : TickerItem) => {
        if (props.onSelect){
          props.onSelect(item);
          return;
      }
    };
    const handleFreebetClose = (changedItem?:Freebet) => {
      setShowFreebet(0);
    }
    var bShowFreebet = (showFreebet > 0);
    return (
      <>
      {bShowFreebet && <EditFreebetDialog freebetId={showFreebet} open={bShowFreebet} onClose={handleFreebetClose} />}
      <DataTable columns={columns} items={props.items} rowsPerPage={25} getId={it => it.couponShareId} orderBy='couponShareId' order='desc'resultFilterEnabled={true} size='xsmall' onSelect={onSelect}  />
      </>
    );
  };
  
  export default TickerTable;
 